import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export const Trust = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="trust-section"
      className="py-20 md:py-28 bg-[#0e0e11] text-neutral-100"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-start">
          <div className="md:col-span-7">
            <div className="aspect-[16/11] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_korean-glow-9/artifacts/dkdq6x1r_1000160211.jpg"
                alt="Treatment in white uniform — professional environment"
                data-testid="certification-image"
                className="w-full h-full object-cover"
                style={{ filter: 'saturate(0.92) brightness(0.98)' }}
              />
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="divider-line"></span>
              <span className="eyebrow text-lilac">{t.trust.eyebrow}</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-neutral-100 tracking-tight mb-10">
              {t.trust.titleA}
              <span className="block italic text-lilac font-light">
                {t.trust.titleB} <span className="not-italic text-[0.7em] align-middle">🇰🇷</span>
              </span>
            </h2>
            <div className="space-y-5">
              <p className="text-lg md:text-xl text-neutral-300 leading-relaxed font-light">
                {t.trust.p1}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
